import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import ButtonWithLoading from "../../components/common/ButtonWithLoading";
import { LoadingPanel } from "../../components/layout/Loading";
import { uploadPortDataFile } from "./services/portDataimport";
import FormFileUpload from "../../components/formFields/FormFileUpload";
import React, { useEffect, useRef } from "react";
import { Typography } from "@progress/kendo-react-common";
import ShadowCard from "../../components/common/ShadowCard";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { clearPortimportDataDetails } from "./portdataimportSlice";
import { Button } from "@progress/kendo-react-buttons";
import { useNavigate } from "react-router-dom";
import { requiredValidator } from "../../components/formFields/CommonValidator";

const UploadPortDataimport: React.FC = () => {
  const dispatch = useAppDispatch();
  const gridRef = useRef<any>(null);
  const navigate = useNavigate();
  const formLoading = useAppSelector((state) => state.portdata.formLoading);

  useEffect(() => {
    return () => {
      dispatch(clearPortimportDataDetails());
    };
  }, []);

  const handleSubmit = async (values: any) => {
    const FileData = new FormData();
    let binaryDoc;
    const file =
      values?.File &&
      typeof values?.File !== "string" &&
      values?.File.length > 0;
    if (file) {
      binaryDoc = values?.File[0]?.getRawFile();
      FileData.append("File", binaryDoc);
      const response = await dispatch(uploadPortDataFile(FileData));

      if (response.payload.Status === 200) {
        navigate("/portimportdata");
      }
    }
  };

  const handleClose = () => {
    navigate("/portimportdata");
  };
  if (formLoading) return <LoadingPanel gridRef={gridRef} />;

  return (
    <>
      <Form
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement>
            <Typography.h4>Port Data Uplod File</Typography.h4>
            <ShadowCard style={{ padding: 12 }}>
              <GridLayout gap={{ rows: 2, cols: 6 }} cols={[{ width: "40%" }]}>
                <GridLayoutItem>
                  <Field
                    name="File"
                    type="File"
                    accept=".xlsx,.xls"
                    label="Port Import File Upload"
                    component={FormFileUpload}
                    validator={requiredValidator}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginTop: 10,
                  }}
                >
                  <ButtonWithLoading
                    label="Upload"
                    type="submit"
                    disabled={!formRenderProps.allowSubmit || formLoading}
                    loading={formLoading}
                  />
                  <Button
                    type="button"
                    fillMode="outline"
                    themeColor="primary"
                    style={{ marginLeft: 4 }}
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                </GridLayoutItem>
              </GridLayout>
            </ShadowCard>
          </FormElement>
        )}
      />
    </>
  );
};

export default UploadPortDataimport;
